/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Manual-install client family.
 */
export const ClientFamily = {
  ClaudeCode: "claude_code",
  ClaudeCowork: "claude_cowork",
  Codex: "codex",
  Cursor: "cursor",
  Opencode: "opencode",
  Other: "other",
} as const;
/**
 * Manual-install client family.
 */
export type ClientFamily = ClosedEnum<typeof ClientFamily>;

export type RecordInstallIntentRequestBody = {
  /**
   * Manual-install client family.
   */
  clientFamily: ClientFamily;
};

/** @internal */
export const ClientFamily$outboundSchema: z.ZodMiniEnum<typeof ClientFamily> = z
  .enum(ClientFamily);

/** @internal */
export type RecordInstallIntentRequestBody$Outbound = {
  client_family: string;
};

/** @internal */
export const RecordInstallIntentRequestBody$outboundSchema: z.ZodMiniType<
  RecordInstallIntentRequestBody$Outbound,
  RecordInstallIntentRequestBody
> = z.pipe(
  z.object({
    clientFamily: ClientFamily$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      clientFamily: "client_family",
    });
  }),
);

export function recordInstallIntentRequestBodyToJSON(
  recordInstallIntentRequestBody: RecordInstallIntentRequestBody,
): string {
  return JSON.stringify(
    RecordInstallIntentRequestBody$outboundSchema.parse(
      recordInstallIntentRequestBody,
    ),
  );
}
